/**
 * Hide Product Variants Without Images
 * Automatically hides variant options that don't have associated product images
 */

(function() {
    'use strict';

    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) return;

    console.log('🖼️ Checking for variants without images...');

    function hideVariantsWithoutImages() {
        // Find all variant-options elements (can be multiple on quick view/recommendations)
        const variantContainers = document.querySelectorAll('variant-options');

        variantContainers.forEach(container => {
            // Get the variant data JSON from the container
            const variantDataScript = container.querySelector('script[type="application/json"]');
            if (!variantDataScript) return;

            let variantData;
            try {
                variantData = JSON.parse(variantDataScript.textContent);
            } catch (e) {
                console.error('Failed to parse variant data:', e);
                return;
            }

            // Create a map of variant options to image availability
            const variantsByOption = {};

            variantData.forEach(variant => {
                const hasImage = variant.featured_media !== null && variant.featured_media !== undefined;

                // Track each option value and whether ANY variant with that option has an image
                variant.options.forEach((optionValue, optionIndex) => {
                    const optionKey = `option${optionIndex + 1}`;

                    if (!variantsByOption[optionKey]) {
                        variantsByOption[optionKey] = {};
                    }

                    if (!variantsByOption[optionKey][optionValue]) {
                        variantsByOption[optionKey][optionValue] = {
                            hasImage: false,
                            variantCount: 0
                        };
                    }

                    variantsByOption[optionKey][optionValue].variantCount++;
                    if (hasImage) {
                        variantsByOption[optionKey][optionValue].hasImage = true;
                    }
                });
            });

            console.log('📊 Variants by option:', variantsByOption);

            // Hide option inputs that don't have images
            const optionSections = container.querySelectorAll('.wt-product__option');

            optionSections.forEach((optionSection, optionIndex) => {
                const optionKey = `option${optionIndex + 1}`;
                const optionData = variantsByOption[optionKey];

                if (!optionData) return;

                // Find all inputs/labels for this option
                const inputs = optionSection.querySelectorAll('input[type="radio"]');

                inputs.forEach(input => {
                    const optionValue = input.value;
                    const optionInfo = optionData[optionValue];

                    if (optionInfo && !optionInfo.hasImage) {
                        // Hide the parent list item
                        const listItem = input.closest('.f-thumb__list__item, .f-pill__list__item, .f-dropdown__list__item');
                        if (listItem) {
                            listItem.style.display = 'none';
                            console.log(`🚫 Hiding variant option: ${optionValue} (no image)`);
                        }
                    }
                });
            });
        });
    }

    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hideVariantsWithoutImages);
    } else {
        hideVariantsWithoutImages();
    }

    // Also run after a short delay to catch any dynamic content
    setTimeout(hideVariantsWithoutImages, 500);

})();
